<div class="container">
    <div class="hero-title">
        <div class="hero-title__icon">
            <ng-container *ngIf="!collectivity; else collectief">
                <ins-hero-header-icon [icon]="icon">
                </ins-hero-header-icon>
            </ng-container>
            <ng-template #collectief>
                <ins-collectivity-sticker location="header" [productId]="productId"></ins-collectivity-sticker>
            </ng-template>
        </div>
        <div class="hero-title__title">
            <h1><ng-content select="hero-title-title,hero-header-title"></ng-content></h1>
        </div>
        <div class="hero-title__aggregate">
            <ng-content select="hero-title-aggregate,hero-header-aggregate"></ng-content>
        </div>
    </div>
</div>

<div class="hero-header" [ngClass]="'hero-header--'+suffix">
    @if (suffix === 'auto') {
    <div class="hero-header__image hero-header__image--image" [ngClass]="'hero-header__image--'+suffix">
        <img [ngSrc]="carImage.src" [ngSrcset]="getSrcSet(carImage.srcset)" [loaderParams]="{ srcset: carImage.srcset }"
            [disableOptimizedSrcset]="true" sizes="100vw" priority fill>
    </div>
    } @else {
    <div class="hero-header__image hero-header__image--image" [ngClass]="'hero-header__image--'+suffix"></div>
    }

    <div class="container">
        <div class="hero-header__content">
            <ng-content select="hero-header-content"></ng-content>
        </div>
    </div>
</div>